export const withdrawalValues = ['4001', '4002', '4003', '4004', '9999'];

export enum WithdrawalRemarks {
  OTHER = '9999'
}
export const WithdrawalMaxValue: number = 300;
export enum IsLockedIndicator {
  IsLockedIndicator = '1'
}
